// Utility for conditional logging
class Logger {
  constructor() {
    this.isDisabled = process.env.REACT_APP_DISABLE_LOGS === 'true';
  }

  log(...args) {
    if (!this.isDisabled) {
      console.log(...args);
    }
  }

  error(...args) {
    if (!this.isDisabled) {
      console.error(...args);
    }
  }

  warn(...args) {
    if (!this.isDisabled) {
      console.warn(...args);
    }
  }

  info(...args) {
    if (!this.isDisabled) {
      console.info(...args);
    }
  }

  debug(...args) {
    if (!this.isDisabled) {
      console.debug(...args);
    }
  }

  group(...args) {
    if (!this.isDisabled) {
      console.group(...args);
    }
  }

  groupEnd() {
    if (!this.isDisabled) {
      console.groupEnd();
    }
  }

  table(data) {
    if (!this.isDisabled) {
      console.table(data);
    }
  }
}

// Create singleton instance
const logger = new Logger();

export default logger;
